import React from 'react';

import { useAd } from '../../../store/hooks/useAd';
import { useAdContext } from '../../../store/contexts/ad';

import {
  List,
  Section,
  ListItem,
  Tooltip,
  Body,
  ActionButton,
  LoadingShimmer
} from '@icarros/ids-react';

import { EDIT_ROUTES } from '../../../utils/adEditRoutes';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';

import { BodyWrapper, ResumeDetailsWrapper, ResumeTitleWrapper, TitleWithTooltip } from './style';

export function VehicleOptionals(): JSX.Element {
  const { currentAd } = useAdContext();
  const { pushToEditForm } = useAd();

  const { opcionais } = currentAd?.veiculo || {};

  return (
    <ResumeDetailsWrapper>
      <ResumeTitleWrapper>
        <TitleWithTooltip>
          <Section size="section_1">opcionais do veículo</Section>
          {currentAd && !opcionais && (
            <Tooltip>
              Os opcionais de um veículo são todos aqueles itens que foram acrescentados ou já são
              de fábrica.
            </Tooltip>
          )}
        </TitleWithTooltip>

        <ActionButton
          iconName="itaufonts_educacao_uso_consc"
          text="editar"
          variant="secondary"
          weight="small"
          onClick={() => {
            pushSellerPFDashboardEvent('opcionais do veículo', 'editar');
            pushToEditForm(EDIT_ROUTES.optionals.name);
          }}
        />
      </ResumeTitleWrapper>
      {currentAd && !opcionais ? (
        <BodyWrapper>
          <Body size="body_2">Você não possui opcionais adicionados.</Body>
        </BodyWrapper>
      ) : (
        <List>
          <LoadingShimmer show={!currentAd} height="60px">
            <ListItem
              label="opcionais selecionados"
              descript={opcionais && String(opcionais.length)}
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('opcionais do veículo', 'editar');
                pushToEditForm(EDIT_ROUTES.optionals.name);
              }}
            />
          </LoadingShimmer>
        </List>
      )}
    </ResumeDetailsWrapper>
  );
}
